<template>
  <div v-html="content"></div>
</template>
<script>
import { client } from "@/api/client";

export default {
  name: "ContratoTratamientoDatos",
  props: {
    business_name: String,
    name: String,
  },
  data() {
    return {
      content: undefined
    }
  },
  async mounted() {
    // let response = await client.get('get_lastest_legal_contract/data_treatment')
    // this.content = response.data.content;
    // Object.entries(this.$props).forEach(element => {
    //   let to_replace = /{{ " + element[0] + " }}/g
    //   this.content = this.content.replaceAll(to_replace, element[1])
    // });
  }
};
</script>
